export default __webpack_public_path__ + "static/media/amaze-1.23336524.jpg";